import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { MyShifts } from '@/features/my-shifts'

// Any authenticated member with a staff profile can view their own shifts — not
// just workers (e.g. a Rostering Manager who also works shifts). The nav only
// surfaces this for staff-profile members, the data endpoint enforces staff
// access (two-hats requireStaffMember), and the page is server-scoped to the
// caller, so a non-staff visitor just sees an empty state.
export const Route = createFileRoute('/_authenticated/_organization/my-shifts/')({
  beforeLoad: async () => requireAuth(),
  component: MyShifts,
})
